import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class OrderStatusEventEmitterService {
  data: any;
  invokeFirstComponentFunction = new EventEmitter();
  subsVar: Subscription;
  subsVar2: Subscription;
  constructor() { }
  emitda(data) {
    this.data = data;
    if ( this.data !== null) {
      for ( let i of this.data) {
        i['showDiv'] = false;
        i['accountHover'] = 0;
        i['accountWidth'] = 0;
        i['accountWidth1'] = 0;
        if (i.ordPrice !== '' && i.ordPrice !== null && i.ordPrice !== 'N/A') {
          i['ordPrice1'] = parseInt(i.ordPrice, 10);
        }
        i.acctTitle = i.acctTitle.replace(/ {5,}/g, '<br>') + ' - ' + i.accountNumber;
        let strSplit = i.acctTitle.split('<br>');
        let longestWord = strSplit.sort(function (a, b) { return b.length - a.length; });
        i['accountWidth1'] = longestWord[0].length;
        i['ordSymbolIdChecker'] = /^[a-zA-Z]+$/.test(i.ordSymbolId);
      }
    }
    this.invokeFirstComponentFunction.emit();
  }
  get() {
    return (this.data);
  }
}
